import { Ar as MinusIcon, C as CollapseIcon, El as AlertTriangleIcon, Et as ToolIcon, Kn as PlusIcon, Lr as MenuIcon, Oi as LLCIcon, Qa as FileIcon, Qs as ChevronUpIcon, R as XIcon, S as DocumentsIcon, Vr as MailOpenIcon, Vt as StarAlt4Icon, Zi as HomeIcon, _c as CashIcon, cc as CheckCircleIcon, fc as ChatIcon, hn as SearchIcon, ic as ChevronDownIcon, il as BankIcon, j as TrashIcon, ln as ShieldIcon, mo as DownloadIcon, tc as ChevronLeftIcon, xl as AlertCircleIcon, yn as ScalesIcon } from "./icons-BxyjaHfi.mjs";
import { $t as cx, At as getChildrenBySlots, Ft as Link$1, Gt as createOverlayOpenEvent, Ht as ActionGroup, Kt as Button$1, L as NotificationWrapper, Qt as cn, S as RichTextEditor, St as Select$1, Y as Input$1, ct as Combobox, g as Skeleton, in as Badge, on as Logo, tn as Spinner, w as RichTextOutputRenderer, zt as Avatar } from "./negroni-Cb3a5kWy.mjs";
import { a as ShellContext, d as isTouchDevice, o as useShellContext } from "./InfoChip-CmK9ustE.mjs";
import SvgErrorFault from "./assets/svg/ErrorFault.mjs";
import { Fragment, createElement, forwardRef, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { DateFormatter, getLocalTimeZone, isToday, parseAbsoluteToLocal } from "@internationalized/date";
import { tv } from "tailwind-variants";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogTrigger, Heading, Link, Modal, ModalOverlay } from "react-aria-components";
import { useDateFormatter, useId } from "react-aria";
import { debounce } from "lodash";
import { useWindowSize } from "usehooks-ts";
import { motion, useAnimate, useMotionValue, useReducedMotion, useTransform } from "framer-motion";
import pluralize from "pluralize";
import { Controller, FormProvider, useForm } from "react-hook-form";
import validator from "validator";
//#region src/application/ActivityFeed/ActivityFeed.tsx
const activityFeedStyles = tv({ slots: {
	activityTimelineWrapper: "relative after:absolute after:left-6 after:top-12 after:block after:h-4 after:w-[1px] after:bg-white",
	lastItemWrapper: "body-1 flex items-center gap-2.5 font-semibold text-neutral-800",
	activityFeedIcon: "flex h-12 w-12 flex-col items-center justify-center rounded-lg bg-white p-3 text-neutral-800",
	activityItemHeadline: "flex min-h-12 grow flex-col gap-2 rounded-lg bg-white px-4 py-3 text-neutral-800 md:flex-row md:items-center md:justify-between",
	timelineDay: "body-1 font-semibold leading-4",
	timelineMonth: "text-[10px] font-medium uppercase leading-3",
	timelineFullDate: "ml-4 flex gap-1 py-2 font-semibold text-neutral-800",
	activityItemWrapper: "relative after:absolute after:left-6 after:top-12 after:block after:h-[calc(100%_-_theme(spacing.8))] after:w-[1px] after:bg-white"
} });
const feedIcons = {
	llc: /* @__PURE__ */ jsx(LLCIcon, {}),
	cash: /* @__PURE__ */ jsx(CashIcon, {}),
	tool: /* @__PURE__ */ jsx(ToolIcon, {}),
	shield: /* @__PURE__ */ jsx(ShieldIcon, {}),
	documents: /* @__PURE__ */ jsx(DocumentsIcon, {}),
	home: /* @__PURE__ */ jsx(HomeIcon, {}),
	scales: /* @__PURE__ */ jsx(ScalesIcon, {}),
	bank: /* @__PURE__ */ jsx(BankIcon, {}),
	mail: /* @__PURE__ */ jsx(MailOpenIcon, {})
};
function getFeedIcon(iconType) {
	return feedIcons[iconType] ?? null;
}
const formatDate = (date, outputFormat) => {
	return new DateFormatter("en-US", outputFormat).format(new Date(date));
};
const { activityTimelineWrapper, activityItemWrapper, lastItemWrapper, activityFeedIcon, activityItemHeadline, timelineDay, timelineMonth, timelineFullDate } = activityFeedStyles();
/**
* Activity item component
*/
function ActivityItem({ id, ctaLabel, ctaTarget, className = "", description, iconType, domain, type, isTaxEvent, renderCtaAction, onLoadEvent }) {
	useEffect(() => {
		onLoadEvent?.({
			ctaLabel,
			ctaTarget,
			id,
			description,
			iconType,
			domain,
			type,
			isTaxEvent
		}, "Load");
	}, []);
	return /* @__PURE__ */ jsxs("div", {
		className: cx("flex gap-2.5", className),
		children: [/* @__PURE__ */ jsx("div", {
			className: activityFeedIcon(),
			children: getFeedIcon(iconType)
		}), /* @__PURE__ */ jsxs("div", {
			className: activityItemHeadline(),
			children: [/* @__PURE__ */ jsx("div", { children: description }), ctaLabel && ctaTarget && renderCtaAction && renderCtaAction({
				ctaLabel,
				ctaTarget,
				id,
				description,
				iconType,
				domain,
				type,
				isTaxEvent
			})]
		})]
	});
}
const timeZone = getLocalTimeZone();
const getDayString = (date) => {
	const itemDate = parseAbsoluteToLocal(new Date(date).toISOString());
	if (isToday(itemDate, timeZone)) return "Today";
	if (isToday(itemDate.add({ days: 1 }), timeZone)) return "Yesterday";
	return "";
};
/**
* Activity timeline component
*/
function ActivityTimeline({ className = "", date }) {
	const [dayNumber, setDayNumber] = useState("");
	const [month, setMonth] = useState("");
	const [relativeDay, setRelativeDay] = useState("");
	const [fullDateString, setFullDateString] = useState("");
	useEffect(() => {
		setDayNumber(formatDate(date, { day: "numeric" }));
		setMonth(formatDate(date, { month: "short" }));
		setRelativeDay(getDayString(date));
		setFullDateString(formatDate(date, {
			month: "short",
			day: "numeric",
			year: "numeric"
		}));
	}, []);
	return /* @__PURE__ */ jsxs("div", {
		className: cx("flex items-center gap-2", className),
		children: [/* @__PURE__ */ jsxs("div", {
			className: activityFeedIcon(),
			children: [/* @__PURE__ */ jsx("div", {
				className: timelineDay(),
				children: dayNumber
			}), /* @__PURE__ */ jsx("div", {
				className: timelineMonth(),
				children: month
			})]
		}), /* @__PURE__ */ jsxs("div", {
			className: timelineFullDate(),
			children: [/* @__PURE__ */ jsx("span", { children: relativeDay }), /* @__PURE__ */ jsx("span", {
				className: "text-neutral-600",
				children: fullDateString
			})]
		})]
	});
}
/**
* ActivityFeed component
* Figma: https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=4007-66033&t=ajfvPPxqMMg3TCwI-4
*/
function ActivityFeed({ className = "", feed, renderCtaAction, onLoadItem, onLoadFeed }) {
	useEffect(() => {
		onLoadFeed?.(feed);
	}, []);
	return /* @__PURE__ */ jsxs("div", {
		className,
		children: [/* @__PURE__ */ jsx("div", {
			className: "pb-3 text-body-1 font-semibold",
			children: "Activity feed"
		}), /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col gap-4",
			children: [feed?.map(({ activityFeedDate, feed: value }) => /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(ActivityTimeline, {
				className: activityTimelineWrapper(),
				date: activityFeedDate
			}), value.map((feedItem) => /* @__PURE__ */ jsx(ActivityItem, {
				className: activityItemWrapper(),
				...feedItem,
				renderCtaAction,
				onLoadEvent: onLoadItem
			}, feedItem.id))] }, activityFeedDate)), /* @__PURE__ */ jsxs("div", {
				className: lastItemWrapper(),
				children: [/* @__PURE__ */ jsx("div", {
					className: activityFeedIcon(),
					children: /* @__PURE__ */ jsx(StarAlt4Icon, {})
				}), /* @__PURE__ */ jsx("div", {
					className: "ml-4",
					children: "You're all caught up!"
				})]
			})]
		})]
	});
}
//#endregion
//#region src/application/MessageThread/utils.ts
/**
* Wraps the react-aria useDateFormatter hook to handle the special cases where
* "Today" and "Yesterday" should be returned instead of the formatted date.
*/
function useDateFormatter$1() {
	const formatter = useDateFormatter({
		month: "long",
		day: "numeric",
		year: "numeric"
	});
	const today = /* @__PURE__ */ new Date();
	const yesterday = /* @__PURE__ */ new Date(today.getTime() - 1440 * 60 * 1e3);
	return (date) => {
		if (date.toDateString() === today.toDateString()) return "Today";
		if (date.toDateString() === yesterday.toDateString()) return "Yesterday";
		return formatter.format(date);
	};
}
function useTimeFormatter() {
	const formatter = useDateFormatter({ timeStyle: "short" });
	return (date) => formatter.format(date);
}
/**
* Group messages in a conversation by day ordered from oldest to most recent.
*/
function mapMessagesToMessagesByDay(messages) {
	if (messages.length === 0) return [];
	messages.sort((a, b) => a.sentDate > b.sentDate ? 1 : -1);
	const messagesByDay = [];
	let currentDay = messages[0].sentDate;
	let currentMessages = [];
	messages.forEach((currentMessage) => {
		const currentMessageDate = currentMessage.sentDate;
		if (currentMessageDate.toDateString() === currentDay.toDateString()) currentMessages.push(currentMessage);
		else {
			messagesByDay.push({
				day: currentDay,
				messages: currentMessages.slice()
			});
			currentDay = currentMessageDate;
			currentMessages = [currentMessage];
		}
	});
	messagesByDay.push({
		day: currentDay,
		messages: currentMessages
	});
	return messagesByDay;
}
//#endregion
//#region src/application/ConversationListCell/ConversationListCell.tsx
function ConversationListCell({ topic, text, senderName, sentDate, isRead, isSentByExternal, onClick, isDeleted, deletedMessageText = "This message has been deleted." }) {
	const formatDate = useDateFormatter$1();
	return /* @__PURE__ */ jsxs(Button, {
		type: "button",
		className: "flex w-full min-w-[200px] flex-row items-center gap-4 rounded-lg bg-neutral-0 p-4",
		onPress: onClick,
		"aria-label": `Open ${topic} conversation`,
		"data-tracking-overrides": JSON.stringify({
			interaction_name: "button | click | open ongoing chat",
			cta_copy: topic
		}),
		children: [/* @__PURE__ */ jsx("div", {
			className: "relative shrink-0",
			children: /* @__PURE__ */ jsx(NotificationWrapper, {
				label: "unread messages",
				notifications: !isRead,
				children: /* @__PURE__ */ jsx(Avatar, {
					name: senderName,
					className: isSentByExternal ? void 0 : "bg-accent2-50"
				})
			})
		}), /* @__PURE__ */ jsxs("div", {
			className: "flex grow flex-col items-stretch text-left",
			children: [
				/* @__PURE__ */ jsxs("div", {
					className: "flex flex-row items-center justify-between",
					children: [/* @__PURE__ */ jsx("span", {
						className: cn("text-body-1", !isRead && "font-semibold"),
						children: topic
					}), /* @__PURE__ */ jsx("span", {
						className: "text-footnote",
						children: formatDate(sentDate)
					})]
				}),
				/* @__PURE__ */ jsx("div", {
					className: "text-body-2 text-neutral-600",
					children: senderName
				}),
				/* @__PURE__ */ jsx("div", {
					className: "line-clamp-1 text-body-2 text-neutral-600",
					children: isDeleted ? /* @__PURE__ */ jsx("div", {
						className: "italic text-neutral-700",
						children: deletedMessageText
					}) : /* @__PURE__ */ jsx(RichTextOutputRenderer, {
						richTextOutput: text,
						forceOpenInNewTab: true
					})
				})
			]
		})]
	});
}
function EmptyConversationListCell() {
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-row items-center gap-4 rounded-lg bg-neutral-0 p-4",
		children: [/* @__PURE__ */ jsx(Avatar, {
			icon: ChatIcon,
			className: "bg-accent2-50"
		}), /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col",
			children: [/* @__PURE__ */ jsx("span", {
				className: "text-body-1 font-semibold",
				children: "You have no recent conversations"
			}), /* @__PURE__ */ jsx("span", {
				className: "text-body-2",
				children: "Your conversations will show up here"
			})]
		})]
	});
}
function NotEntitledConversationListCell() {
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-row items-center gap-4 rounded-lg bg-neutral-0 p-4",
		children: [/* @__PURE__ */ jsx(Avatar, {
			icon: ChatIcon,
			className: "bg-accent2-50"
		}), /* @__PURE__ */ jsx("span", {
			className: "text-body-1 font-semibold",
			children: "Your conversations will show up here"
		})]
	});
}
//#endregion
//#region src/application/ExpertCard/ExpertCard.tsx
function ExpertCard({ children }) {
	const { header, body, footer } = getChildrenBySlots(children, {
		header: Header$1,
		body: Body,
		footer: Footer
	});
	return /* @__PURE__ */ jsxs("div", {
		className: "flex h-full flex-col justify-between rounded-lg bg-neutral-50 p-4",
		children: [
			header,
			body,
			footer
		]
	});
}
function Header$1({ icon }) {
	return /* @__PURE__ */ jsx("div", {
		className: "mb-8 flex flex-row gap-1",
		children: /* @__PURE__ */ jsx("div", {
			className: "flex -space-x-2",
			children: (Array.isArray(icon) ? icon : [icon]).map((iconItem, index) => /* @__PURE__ */ jsx(Avatar, {
				icon: iconItem,
				className: "bg-accent2-100 text-neutral-0"
			}, index))
		})
	});
}
function Body({ name, subtext }) {
	return /* @__PURE__ */ jsxs("div", {
		className: "mb-4 flex-grow",
		children: [/* @__PURE__ */ jsx("div", {
			className: "text-body-1 font-semibold text-neutral-800",
			children: name
		}), /* @__PURE__ */ jsx("div", {
			className: "text-body-1 text-neutral-600",
			children: subtext
		})]
	});
}
function Footer({ buttons }) {
	return /* @__PURE__ */ jsx("div", {
		className: "flex flex-row gap-2",
		children: buttons?.map((button, index) => /* @__PURE__ */ jsx("div", {
			className: "grow",
			children: button
		}, index))
	});
}
ExpertCard.Header = Header$1;
ExpertCard.Body = Body;
ExpertCard.Footer = Footer;
//#endregion
//#region src/application/ErrorContainer/ErrorContainer.tsx
function ErrorContainer({ children, title }) {
	return /* @__PURE__ */ jsx("div", {
		className: "centered-container mt-[72px]",
		children: /* @__PURE__ */ jsx("div", {
			className: "rounded-lg bg-white shadow-level-2",
			children: /* @__PURE__ */ jsxs("div", {
				className: "flex flex-col p-4 md:p-6",
				children: [
					/* @__PURE__ */ jsx("div", {
						className: "flex justify-center pt-4",
						children: /* @__PURE__ */ jsx(SvgErrorFault, {})
					}),
					title?.length && /* @__PURE__ */ jsx("h2", {
						className: "typography-subtitle-1 md:typography-highlight-2 pb-2 pt-3 text-center",
						children: title
					}),
					/* @__PURE__ */ jsx("p", {
						className: "typography-caption-1 md:typography-content-3 pb-6 text-center",
						children
					})
				]
			})
		})
	});
}
//#endregion
//#region src/application/FileChip/fileChipStyles.ts
const fileChipStyles = tv({
	slots: {
		container: "group flex w-full flex-col rounded-lg text-left outline-none transition-colors duration-200 ease-out focus-visible:outline-kbf",
		bodyContainer: "",
		body: "align-center flex justify-between",
		title: "text-body-1 font-semibold",
		subtext: "text-body-2",
		previewContainer: "relative h-30 rounded-t-lg border-x border-t border-solid px-6 pt-6 transition-transform",
		imagePreview: "h-full w-full rounded-t-lg object-cover object-top",
		imagePlaceholder: "h-full rounded-t-lg bg-neutral-0",
		actionGroupContainer: "absolute right-3.5 top-[15px]"
	},
	variants: {
		size: {
			xl: {
				container: "relative w-[200px]",
				bodyContainer: "z-10 rounded-b-lg border border-solid bg-neutral-0 p-4",
				title: "line-clamp-2",
				body: "flex-col-reverse",
				subtext: "line-clamp-1"
			},
			sm: {
				container: "justify-center p-2",
				body: "h-6 gap-2",
				title: "line-clamp-1 font-normal text-neutral-800",
				subtext: "line-clamp-1"
			},
			md: {
				container: "justify-center py-2 pl-4 pr-3",
				title: "line-clamp-1",
				body: "h-11 gap-2",
				subtext: "line-clamp-1"
			},
			lg: {
				container: "pb-4 pl-4 pr-3 pt-3",
				title: "line-clamp-1",
				body: "flex-col-reverse gap-1"
			}
		},
		isDisabled: {
			true: { container: "cursor-default" },
			false: ""
		},
		isKeyDownPressed: {
			true: "",
			false: ""
		},
		isBodyClickable: {
			true: "",
			false: ""
		}
	},
	compoundVariants: [
		{
			size: "xl",
			isDisabled: true,
			class: {
				container: "pointer-events-none",
				bodyContainer: "border-neutral-100 border-t-neutral-50 bg-neutral-25",
				title: "text-neutral-300",
				subtext: "text-neutral-300",
				previewContainer: "border-neutral-100 bg-neutral-200"
			}
		},
		{
			size: "xl",
			isDisabled: false,
			class: {
				bodyContainer: "border-neutral-50 group-focus-visible:border-neutral-100 group-focus-visible:border-t-neutral-50 group-focus-visible:bg-neutral-200",
				previewContainer: "border-neutral-50 transition-all duration-200 ease-out group-focus-visible:border-neutral-100 group-focus-visible:bg-neutral-200 group-focus-visible:px-3 group-focus-visible:pt-3"
			}
		},
		{
			size: "xl",
			isDisabled: false,
			isKeyDownPressed: true,
			class: { bodyContainer: "group-focus-visible:border-t-neutral-50 group-focus-visible:bg-neutral-300" }
		},
		{
			size: "xl",
			isBodyClickable: true,
			class: {
				bodyContainer: "transition-colors duration-200 ease-out group-hover:border-neutral-100 group-hover:border-t-neutral-50 group-hover:bg-neutral-200 group-active:border-t-neutral-50 group-active:bg-neutral-300 group-[&:active:has(.action-group-container:active)]:border-neutral-50 group-[&:hover:has(.action-group-container:hover)]:border-neutral-50 group-[&:active:has(.action-group-container:active)]:bg-neutral-0 group-[&:hover:has(.action-group-container:hover)]:bg-neutral-0",
				previewContainer: "border-neutral-50 bg-neutral-100 group-hover:border-neutral-100 group-hover:bg-neutral-200 group-hover:px-3 group-hover:pt-3 group-focus-visible:border-neutral-100 group-focus-visible:bg-neutral-200 group-focus-visible:px-3 group-focus-visible:pt-3 group-[&:hover:has(.action-group-container:hover)]:border-neutral-50 group-[&:hover:has(.action-group-container:hover)]:bg-neutral-100 group-[&:hover:has(.action-group-container:hover)]:px-6 group-[&:hover:has(.action-group-container:hover)]:pt-6"
			}
		},
		{
			size: "xl",
			isBodyClickable: false,
			class: {
				container: "cursor-default",
				previewContainer: "border-neutral-50 bg-neutral-100"
			}
		},
		{
			size: [
				"sm",
				"md",
				"lg"
			],
			isDisabled: false,
			class: {
				bodyContainer: "w-full",
				container: "rounded-lg border border-solid border-neutral-50 bg-neutral-0 focus-visible:bg-neutral-200 [&:active:has(.action-group-container:active)]:border-neutral-50 [&:active:has(.action-group-container:active)]:bg-neutral-0 [&:hover:has(.action-group-container:hover)]:border-neutral-50 [&:hover:has(.action-group-container:hover)]:bg-neutral-0"
			}
		},
		{
			size: [
				"sm",
				"md",
				"lg"
			],
			isBodyClickable: true,
			class: { container: "hover:border-neutral-100 hover:bg-neutral-200 active:border-neutral-100 active:bg-neutral-300" }
		},
		{
			size: [
				"sm",
				"md",
				"lg"
			],
			isBodyClickable: false,
			class: { container: "cursor-default" }
		},
		{
			size: [
				"sm",
				"md",
				"lg"
			],
			isDisabled: false,
			isKeyDownPressed: true,
			class: { container: "focus-visible:border-neutral-100 focus-visible:bg-neutral-300" }
		},
		{
			size: [
				"sm",
				"md",
				"lg"
			],
			isDisabled: true,
			class: {
				container: "pointer-events-none rounded-lg border-neutral-50 bg-neutral-25",
				title: "text-neutral-300",
				subtext: "text-neutral-300"
			}
		}
	]
});
//#endregion
//#region src/application/FileChip/FileChipBody.tsx
function FileChipBody({ title, subtext = "", size = "xl", badgeLabel, badgeColor, badgeIcon, actionGroupItems, onActionGroupAction, isDisabled = false }) {
	const { body, title: titleStyle, subtext: subtextStyle } = fileChipStyles({
		size,
		isDisabled
	});
	return /* @__PURE__ */ jsxs("div", {
		className: body(),
		children: [/* @__PURE__ */ jsxs("div", {
			className: "flex flex-row",
			children: [(size === "sm" || size === "md") && /* @__PURE__ */ jsx(FileIcon, { className: cn("mr-2.5 shrink-0 self-center", isDisabled && "text-neutral-300") }), /* @__PURE__ */ jsxs("div", {
				className: "flex flex-col self-center overflow-hidden",
				children: [/* @__PURE__ */ jsx("div", {
					className: titleStyle(),
					children: /* @__PURE__ */ jsx("div", {
						className: "text-ellipsis",
						children: title
					})
				}), size !== "sm" && /* @__PURE__ */ jsx("div", {
					className: subtextStyle(),
					children: subtext
				})]
			})]
		}), size !== "xl" && /* @__PURE__ */ jsxs("div", {
			className: cn("flex items-center justify-end", size === "md" ? "gap-2" : "gap-1"),
			children: [(!!badgeLabel || !!badgeIcon) && /* @__PURE__ */ jsx(Badge, {
				label: badgeLabel,
				color: badgeColor,
				icon: badgeIcon
			}), !!onActionGroupAction && !!actionGroupItems && /* @__PURE__ */ jsx("div", {
				className: "action-group-container",
				children: /* @__PURE__ */ jsx(ActionGroup, {
					maxDisplayedItems: size === "sm" ? 1 : 2,
					items: actionGroupItems,
					onAction: onActionGroupAction,
					isAllDisabled: isDisabled
				})
			})]
		})]
	});
}
//#endregion
//#region src/application/FileChip/FileChipPreview.tsx
function FileChipPreview({ size, src, badgeLabel, badgeColor, badgeIcon, icon: Icon, actionGroupItems, onActionGroupAction, isDisabled = false, isBodyClickable }) {
	const { previewContainer, imagePlaceholder, imagePreview, actionGroupContainer } = fileChipStyles();
	if (size !== "xl") return null;
	const displayActionGroup = !!actionGroupItems && !!onActionGroupAction;
	return /* @__PURE__ */ jsxs("div", {
		className: previewContainer({
			isDisabled,
			size,
			isBodyClickable
		}),
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: imagePlaceholder(),
				"data-testid": "previewPlaceholder",
				children: [Icon && /* @__PURE__ */ jsx(Icon, {}), src && /* @__PURE__ */ jsx("img", {
					className: imagePreview(),
					alt: "documentPreview",
					src
				})]
			}),
			(!!badgeLabel || !!badgeIcon) && /* @__PURE__ */ jsx("div", {
				className: "absolute bottom-2 right-3.5",
				children: /* @__PURE__ */ jsx(Badge, {
					label: badgeLabel,
					color: badgeColor,
					icon: badgeIcon
				})
			}),
			displayActionGroup && /* @__PURE__ */ jsx("div", {
				className: cn("action-group-container", actionGroupContainer()),
				children: /* @__PURE__ */ jsx(ActionGroup, {
					maxDisplayedItems: 2,
					items: actionGroupItems,
					onAction: onActionGroupAction,
					isAllDisabled: isDisabled
				})
			})
		]
	});
}
//#endregion
//#region src/application/FileChip/FileChip.tsx
function FileChipDocument() {
	return /* @__PURE__ */ jsxs("svg", {
		viewBox: "0 0 136 93",
		fill: "none",
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M0 8C0 3.58172 3.58172 0 8 0H128C132.418 0 136 3.58172 136 8V93H0V8Z",
				fill: "white"
			}),
			/* @__PURE__ */ jsx("rect", {
				x: "14",
				y: "18",
				width: "90",
				height: "7",
				rx: "2",
				fill: "#E9E6E2"
			}),
			/* @__PURE__ */ jsx("rect", {
				x: "14",
				y: "60",
				width: "110",
				height: "7",
				rx: "2",
				fill: "#E9E6E2"
			}),
			/* @__PURE__ */ jsx("rect", {
				x: "14",
				y: "71",
				width: "110",
				height: "7",
				rx: "2",
				fill: "#E9E6E2"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M14 84C14 82.8954 14.8954 82 16 82H122C123.105 82 124 82.8954 124 84V86H14V84Z",
				fill: "#E9E6E2"
			}),
			/* @__PURE__ */ jsx("rect", {
				x: "14",
				y: "31",
				width: "50",
				height: "7",
				rx: "2",
				fill: "#E9E6E2"
			})
		]
	});
}
function FileChip(props) {
	const { title, subtext = "", size = "xl", previewSrc, previewIcon, onClick, badgeLabel = "", badgeColor = "neutral", badgeIcon, className = "", actionGroupItems, onActionGroupAction, isDisabled = false, ...restProps } = props;
	const divRef = useRef(null);
	const [isKeyDownPressed, setIsKeyDownPressed] = useState(false);
	const handleOnKeyDown = (e) => {
		if (debouncedOnClick === void 0) return;
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			debouncedOnClick();
			setIsKeyDownPressed(true);
		}
	};
	const handleOnKeyUp = (e) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			setIsKeyDownPressed(false);
		}
	};
	const { container, bodyContainer } = fileChipStyles({
		size,
		isDisabled,
		isKeyDownPressed,
		isBodyClickable: !!onClick
	});
	const sharedProps = {
		size,
		badgeLabel,
		badgeColor,
		badgeIcon,
		actionGroupItems,
		onActionGroupAction,
		isDisabled
	};
	const debouncedOnClick = useMemo(() => {
		if (onClick === void 0) return;
		return debounce(() => {
			divRef.current?.click();
		}, 500);
	}, [onClick]);
	return /* @__PURE__ */ jsxs("div", {
		ref: divRef,
		tabIndex: isDisabled || !onClick ? -1 : 0,
		role: "button",
		className: container({ className }),
		onClick,
		onKeyDown: handleOnKeyDown,
		onKeyUp: handleOnKeyUp,
		...restProps,
		children: [/* @__PURE__ */ jsx(FileChipPreview, {
			isBodyClickable: !!onClick,
			src: previewSrc,
			icon: previewIcon,
			...sharedProps
		}), /* @__PURE__ */ jsx("div", {
			className: bodyContainer(),
			children: /* @__PURE__ */ jsx(FileChipBody, {
				title,
				subtext,
				...sharedProps
			})
		})]
	});
}
//#endregion
//#region src/application/MessageThread/MessageFailed.tsx
function MessageFailed({ retrySend, isDisabled }) {
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-row items-baseline gap-1",
		children: [
			/* @__PURE__ */ jsx(AlertCircleIcon, {
				size: "xs",
				className: "self-center text-error-500"
			}),
			/* @__PURE__ */ jsx("p", {
				className: "text-footnote font-normal text-error-500",
				children: "Message failed to send."
			}),
			/* @__PURE__ */ jsx(Button$1, {
				size: "sm",
				color: "error",
				variant: "ghost",
				className: "h-4 px-0 text-footnote",
				onPress: retrySend,
				isDisabled,
				children: "Retry"
			})
		]
	});
}
//#endregion
//#region src/application/MessageThread/MessageRow.tsx
function MessageRow({ message, sendMessage, deletedMessageText = "This message has been deleted.", isDisabled, handleDocumentAction }) {
	const formatTime = useTimeFormatter();
	const { id, text, senderName, sentDate, isSenderExternal, sendFailed, isDeleted } = message;
	const document = message.document;
	if (document) {
		const primaryTag = document.tags?.[0];
		const createdAt = document.createdAt;
		const documentName = document.documentName;
		const isArchived = document.isArchived;
		return /* @__PURE__ */ jsx(FileChip, {
			size: "md",
			className: "min-h-11 [&_.line-clamp-1]:line-clamp-2 [&_.text-ellipsis]:line-clamp-2 [&_.text-ellipsis]:break-all",
			subtext: `Uploaded ${formatTime(new Date(createdAt))}`,
			title: documentName,
			badgeLabel: primaryTag?.displayName,
			actionGroupItems: [{
				id: "action-download",
				icon: DownloadIcon,
				label: "Download"
			}],
			onActionGroupAction: (action) => {
				handleDocumentAction?.({
					action,
					documents: [document]
				});
			},
			isDisabled: isArchived
		});
	}
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col gap-2",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "flex flex-row items-center gap-2",
			children: [/* @__PURE__ */ jsx(Avatar, {
				name: senderName,
				className: isSenderExternal ? void 0 : "bg-accent2-50"
			}), /* @__PURE__ */ jsxs("div", {
				className: "flex grow flex-row items-center justify-between",
				children: [/* @__PURE__ */ jsx("p", {
					className: "text-body-1",
					children: senderName
				}), /* @__PURE__ */ jsx("p", {
					className: "text-footnote text-neutral-600",
					children: formatTime(sentDate)
				})]
			})]
		}), isDeleted ? /* @__PURE__ */ jsx("div", {
			className: "italic text-neutral-700",
			children: deletedMessageText
		}) : /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(RichTextOutputRenderer, { richTextOutput: text || "" }), sendFailed && text !== null && /* @__PURE__ */ jsx(MessageFailed, {
			isDisabled,
			retrySend: () => sendMessage(text, sendFailed ? id : void 0)
		})] })]
	});
}
//#endregion
//#region src/application/MessageThread/MessageThread.tsx
function DateRow({ date }) {
	const formatDate = useDateFormatter$1();
	return /* @__PURE__ */ jsxs("div", {
		className: "relative text-center",
		children: [/* @__PURE__ */ jsx("div", { className: "absolute left-0 top-1/2 h-px w-full bg-neutral-50" }), /* @__PURE__ */ jsx("p", {
			className: "relative inline-block bg-white px-3 text-footnote font-normal uppercase text-neutral-600",
			children: formatDate(date)
		})]
	});
}
function NewMessageDivider() {
	return /* @__PURE__ */ jsxs("div", {
		className: "relative text-center",
		children: [/* @__PURE__ */ jsx("div", { className: "absolute left-0 top-1/2 h-px w-full bg-brand-500" }), /* @__PURE__ */ jsx("p", {
			className: "relative inline-block bg-white px-3 text-footnote font-semibold uppercase text-brand-500",
			children: "NEW"
		})]
	});
}
function shouldShowNewMessageDivider(oldestIndex, messageIndex) {
	return oldestIndex === messageIndex;
}
function findOldestUnread(messages, isExternalViewer) {
	let oldestUnreadIndex = -1;
	for (let i = 0; i < messages.length; i++) {
		const isOppositeRoleSender = isExternalViewer ? !messages[i].isSenderExternal : messages[i].isSenderExternal;
		if (!messages[i].isRead && isOppositeRoleSender) {
			oldestUnreadIndex = i;
			break;
		}
	}
	return oldestUnreadIndex;
}
/** Message Thread provides a chat experience utilizing the RichTextEditor component
*
* Warning: When using this component with server side rendering, you may need to specify it to be rendered on the client.
* E.g. with Remix SSR, this component (or it's parent) should be wrapped with `ClientOnly`.
*/
function MessageThread({ parentId, messages = [], isClosed = false, sendMessage, markAsRead, onChange, isDisabled = false, failedMessages, placeholder, scrollToBottomOnChange, closedConversationText, deletedMessageText, hideFailedMessageWarning, sendButtonAriaLabel, id, "data-testid": dataTestId, "data-tracking-additionals": trackingAdditionals, className, isExternalViewer = true, hasError = false, errorMessage = "", invalidCharsPattern = /$^/, disableSendButton = false, handleDocumentAction, customActions, footerContent }) {
	const messagesByDay = mapMessagesToMessagesByDay([...messages, ...hideFailedMessageWarning ? failedMessages : failedMessages.map((message) => ({
		...message,
		sendFailed: true
	}))]);
	const closedConversationMessage = closedConversationText || `Your conversation with ${messages.slice().reverse().find((m) => !m.isSenderExternal)?.senderName} has ended. If you have
    any more questions or need assistance, please start a new
    conversation.`;
	const messagesEndRef = useRef(null);
	const scrollToBottom = useCallback(() => {
		messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
	}, [messagesEndRef]);
	const handleSendMessage = (serializedEditorState) => {
		if (serializedEditorState) sendMessage(JSON.stringify(serializedEditorState));
	};
	useEffect(() => {
		if (scrollToBottomOnChange) scrollToBottom();
	}, [messages]);
	useEffect(() => {
		if (scrollToBottomOnChange) window.visualViewport?.addEventListener("resize", scrollToBottom);
		return () => {
			if (scrollToBottomOnChange) window.visualViewport?.removeEventListener("resize", scrollToBottom);
		};
	}, []);
	useEffect(() => {
		if (parentId) markAsRead?.();
	}, [parentId]);
	return /* @__PURE__ */ jsxs("div", {
		id,
		"data-testid": dataTestId,
		className: cx("flex flex-col justify-between", className),
		children: [/* @__PURE__ */ jsxs("div", {
			className: "flex min-h-0 shrink flex-col gap-4 overflow-y-auto",
			children: [messagesByDay.map(({ day, messages: dayMessages }) => {
				return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(DateRow, { date: day }, "date"), dayMessages.map((message, index) => /* @__PURE__ */ jsxs(Fragment, { children: [shouldShowNewMessageDivider(findOldestUnread(dayMessages, isExternalViewer), index) ? /* @__PURE__ */ jsx(NewMessageDivider, {}) : null, /* @__PURE__ */ jsx(MessageRow, {
					message,
					sendMessage,
					deletedMessageText,
					isDisabled,
					handleDocumentAction
				}, message.id)] }, message.id))] }, day.toString());
			}), /* @__PURE__ */ jsx("div", { ref: messagesEndRef })]
		}), isClosed ? /* @__PURE__ */ jsx("div", {
			className: "text-center",
			children: /* @__PURE__ */ jsx("p", {
				className: "text-body-2 text-neutral-600",
				children: closedConversationMessage
			})
		}) : /* @__PURE__ */ jsxs(Fragment$1, { children: [footerContent, /* @__PURE__ */ jsx(RichTextEditor, {
			onChange,
			onSend: handleSendMessage,
			placeHolder: placeholder,
			hasError,
			errorMessage,
			errorIcon: AlertTriangleIcon,
			sendButtonAriaLabel,
			isDisabled,
			invalidCharsPattern,
			disableSendButton,
			customActions,
			"data-tracking-additionals": trackingAdditionals
		})] })]
	});
}
//#endregion
//#region src/application/ProcessingButton/ProcessingButton.tsx
function ProcessingButton({ children, processingText, isDisabled, isProcessing, onSubmit, ...buttonProps }) {
	const { onPress: _onPress, type: _type, ...btnProps } = buttonProps;
	return /* @__PURE__ */ jsxs(Button$1, {
		type: "submit",
		onPress: onSubmit,
		isDisabled: isProcessing || isDisabled,
		...btnProps,
		children: [isProcessing && /* @__PURE__ */ jsxs("div", {
			className: "flex items-center font-semibold text-neutral-600",
			children: [/* @__PURE__ */ jsx(Spinner, { size: "xs" }), processingText]
		}), !isProcessing && children]
	});
}
//#endregion
//#region src/application/ShortcutsBase/ShortcutsBase.tsx
const shortcutsBaseStyles = tv({
	slots: {
		underlay: "fixed bottom-0 left-0 right-0 top-0 z-30 animate-fade-in-300ms overflow-hidden bg-scrim data-[exiting]:animate-fade-out-300ms",
		modal: "[&>section]:animate-slide-in-horizontal [&>section]:data-[exiting]:animate-slide-out-horizontal",
		dialog: "absolute left-0 top-6 flex h-[calc(var(--visual-viewport-height)_-_24px)] w-full flex-col rounded-lg bg-neutral-0 outline-none md:left-6 md:h-[calc(var(--visual-viewport-height)_-_48px)] md:w-[525px] lg:w-[600px]",
		heading: "flex items-center gap-2 p-4",
		children: "flex-grow overflow-y-auto rounded-lg"
	},
	variants: {
		navIsExpanded: {
			true: { underlay: "md:left-negroniNavigation" },
			false: { underlay: "md:left-negroniNavigationCollapsed" }
		},
		title: {
			true: { heading: "justify-between" },
			false: { heading: "justify-end" }
		}
	}
});
const emitOverlayOpenEvent = (ref, title) => {
	if (!ref.current) return;
	const overlayOpenEvent = createOverlayOpenEvent({
		id: ref.current.id,
		title,
		type: "shortcuts_base"
	});
	ref.current.dispatchEvent(overlayOpenEvent);
};
function ShortcutsBase({ title = "", isOpen, onClose, children, navIsExpanded, onBackButtonClick, actionButton, brandingContent, ...props }) {
	const { underlay, modal, dialog, heading, children: childrenStyle } = shortcutsBaseStyles();
	const dialogRef = useRef(null);
	useEffect(() => {
		if (isOpen) emitOverlayOpenEvent(dialogRef, title);
	}, [isOpen, title]);
	return /* @__PURE__ */ jsx(ModalOverlay, {
		isDismissable: true,
		className: underlay({ navIsExpanded }),
		isOpen,
		onOpenChange: onClose,
		children: /* @__PURE__ */ jsx(Modal, {
			className: modal(),
			children: /* @__PURE__ */ jsxs(Dialog, {
				className: dialog(),
				...props,
				ref: dialogRef,
				children: [/* @__PURE__ */ jsxs(Heading, {
					className: heading({ title: !!title }),
					children: [
						(title || onBackButtonClick) && /* @__PURE__ */ jsxs("div", {
							className: "flex grow flex-row items-center justify-start",
							children: [
								onBackButtonClick && /* @__PURE__ */ jsx(Button$1, {
									"aria-label": "Back",
									icon: ChevronLeftIcon,
									variant: "ghost",
									color: "neutral",
									size: "sm",
									onPress: onBackButtonClick
								}),
								/* @__PURE__ */ jsx("div", {
									className: "text-body-1 font-semibold",
									children: title
								}),
								!!brandingContent && /* @__PURE__ */ jsx("div", {
									className: "ml-2",
									children: brandingContent
								})
							]
						}),
						actionButton,
						/* @__PURE__ */ jsx(Button$1, {
							icon: XIcon,
							variant: "outline",
							color: "neutral",
							size: "sm",
							onPress: onClose
						})
					]
				}), /* @__PURE__ */ jsx("div", {
					className: childrenStyle(),
					children
				})]
			})
		})
	});
}
//#endregion
//#region src/application/Stepper/Stepper.tsx
const { wrapper, counter, button } = tv({
	slots: {
		wrapper: "flex w-fit items-center gap-2 rounded-lg bg-neutral-100",
		counter: "flex h-8 w-9 min-w-radio select-none items-center justify-center rounded-lg bg-neutral-0 p-1",
		button: "[&>button]:h-3 [&>button]:w-3 [&>button]:p-0"
	},
	variants: { orientation: {
		horizontal: { wrapper: "px-2 py-1" },
		vertical: { wrapper: "flex-col-reverse px-1 py-2" }
	} }
})();
function StepperButton({ icon, onClick }) {
	return /* @__PURE__ */ jsx("span", {
		className: button(),
		children: /* @__PURE__ */ jsx(Button$1, {
			icon,
			size: "sm",
			onPress: onClick,
			variant: "ghost",
			color: "neutral"
		})
	});
}
const clamp = (value, min = Number.NEGATIVE_INFINITY, max = Number.POSITIVE_INFINITY) => {
	return Math.min(Math.max(value, min), max);
};
function Stepper({ orientation = "horizontal", defaultValue = 0, min, max, step = 1, onChange, onMinusClick, onPlusClick }) {
	if (min != null && max != null && min > max) throw new Error("Stepper: min value cannot be greater than the max value.");
	if (step < 1) throw new Error("Stepper: step prop cannot be lesser than 1.");
	const [value, setValue] = useState(clamp(defaultValue, min, max));
	const handleOnMinusClick = () => {
		const newValue = clamp(value - step, min, max);
		setValue(newValue);
		onMinusClick?.(newValue);
		onChange?.(newValue);
	};
	const handleOnPlusClick = () => {
		const newValue = clamp(value + step, min, max);
		setValue(newValue);
		onPlusClick?.(newValue);
		onChange?.(newValue);
	};
	return /* @__PURE__ */ jsxs("div", {
		className: wrapper({ orientation }),
		children: [
			/* @__PURE__ */ jsx(StepperButton, {
				icon: MinusIcon,
				onClick: handleOnMinusClick
			}),
			/* @__PURE__ */ jsx("div", {
				className: counter(),
				children: value
			}),
			/* @__PURE__ */ jsx(StepperButton, {
				icon: PlusIcon,
				onClick: handleOnPlusClick
			})
		]
	});
}
//#endregion
//#region src/application/DocumentCell/DocumentCell.tsx
const documentCellStyles = tv({
	slots: {
		wrapper: "flex w-full items-center justify-start border-b border-b-neutral-100 p-4 text-sm",
		icon: ""
	},
	variants: { variant: {
		error: { icon: "text-error-500" },
		success: { icon: "text-success-500" },
		uploading: { icon: "" }
	} }
});
function DocumentCellStatus({ variant }) {
	if (!variant) return null;
	const { icon } = documentCellStyles({ variant });
	return /* @__PURE__ */ jsx("div", {
		className: "mr-4",
		children: variant === "uploading" ? /* @__PURE__ */ jsx(Spinner, {
			size: "sm",
			className: "m-0"
		}) : variant === "error" ? /* @__PURE__ */ jsx(AlertCircleIcon, { className: icon() }) : /* @__PURE__ */ jsx(CheckCircleIcon, { className: icon() })
	});
}
function DocumentCell({ title, description, cta, ctaTarget = "_self", ctaOnPress, variant, className }) {
	const { wrapper } = documentCellStyles();
	return /* @__PURE__ */ jsxs("div", {
		className: wrapper({
			variant,
			className
		}),
		children: [/* @__PURE__ */ jsx(DocumentCellStatus, { variant }), /* @__PURE__ */ jsxs("div", {
			className: "flex min-w-0 grow items-center justify-between",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "min-w-0",
				children: [/* @__PURE__ */ jsx("div", {
					className: "truncate text-body-1",
					children: title
				}), /* @__PURE__ */ jsx("div", {
					className: "text-footnote text-neutral-700",
					children: description
				})]
			}), cta && /* @__PURE__ */ jsx("div", {
				className: "ml-4 whitespace-nowrap",
				children: /* @__PURE__ */ jsx(Link$1, {
					color: "neutral",
					size: "lg",
					className: "underline",
					onPress: ctaOnPress,
					target: ctaTarget,
					children: cta
				})
			})]
		})]
	});
}
//#endregion
//#region src/application/UploadDocTracker/helpers.ts
function uploadProgress(documents) {
	let errorCount = 0;
	let successCount = 0;
	let uploadingCount = 0;
	documents.forEach((document) => {
		switch (document.status) {
			case "error":
				errorCount += 1;
				break;
			case "success":
				successCount += 1;
				break;
			case "uploading":
				uploadingCount += 1;
				break;
			default: break;
		}
	});
	return [
		errorCount ? `${errorCount} ${pluralize("item", errorCount)} failed` : "",
		uploadingCount ? `${uploadingCount} ${pluralize("item", uploadingCount)} uploading` : "",
		successCount ? `${successCount} ${pluralize("item", successCount)} complete` : ""
	].filter((message) => message !== "").join(", ");
}
function getDescription(status, description) {
	if (description) return description;
	switch (status) {
		case "uploading": return "Uploading...";
		case "success": return "Upload complete";
		default: return "";
	}
}
//#endregion
//#region src/application/UploadDocTracker/UploadHeader.tsx
function UploadHeader({ documents, isExpanded, isSwipeable, onToggle, onClose }) {
	const progress = uploadProgress(documents);
	const canClose = !documents.some((document) => document.status === "uploading");
	return /* @__PURE__ */ jsxs("div", {
		className: "border-b border-b-neutral-100 px-3 py-4",
		children: [isSwipeable && /* @__PURE__ */ jsx("div", {
			className: "relative pb-4",
			children: /* @__PURE__ */ jsx(Button, {
				className: "t-0 absolute left-1/2 -translate-x-1/2 p-2 focus:outline-none active:outline-none",
				onPress: onToggle,
				children: /* @__PURE__ */ jsx("svg", {
					width: "23",
					height: "4",
					viewBox: "0 0 23 4",
					fill: "none",
					children: /* @__PURE__ */ jsx("path", {
						d: "M2.5 2H20.5",
						strokeWidth: "4",
						strokeLinecap: "round",
						className: "stroke-neutral-300"
					})
				})
			})
		}), /* @__PURE__ */ jsxs("div", {
			className: "flex items-center",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "grow",
				children: [
					/* @__PURE__ */ jsx("div", {
						className: "text-body-1 font-semibold",
						children: "Uploads"
					}),
					" ",
					/* @__PURE__ */ jsx("div", {
						className: "text-footnote text-neutral-700",
						children: progress
					})
				]
			}), /* @__PURE__ */ jsxs("div", {
				className: "ml-4 flex gap-3",
				children: [!isSwipeable && /* @__PURE__ */ jsx(Button$1, {
					"aria-label": "toggle",
					tooltip: "Toggle",
					size: "sm",
					variant: "ghost",
					color: "neutral",
					icon: isExpanded ? ChevronDownIcon : ChevronUpIcon,
					onPress: onToggle,
					className: "hidden md:flex"
				}), canClose && /* @__PURE__ */ jsx(Button$1, {
					tooltip: "close",
					"aria-label": "close",
					size: "sm",
					variant: "ghost",
					color: "neutral",
					icon: XIcon,
					onPress: onClose
				})]
			})]
		})]
	});
}
//#endregion
//#region src/application/UploadDocTracker/UploadSheet.tsx
const uploadSheetStyles = tv({
	slots: {
		wrapper: "overflow-y-hidden transition-all motion-reduce:transition-none",
		scrollArea: "max-h-[365px] overflow-y-auto"
	},
	variants: { isExpanded: {
		true: { wrapper: "max-h-[365px]" },
		false: { wrapper: "max-h-0" }
	} }
});
const UploadSheet = forwardRef(({ documents, isExpanded }, ref) => {
	const { wrapper, scrollArea } = uploadSheetStyles();
	return /* @__PURE__ */ jsx("div", {
		className: wrapper({ isExpanded }),
		ref,
		children: /* @__PURE__ */ jsx("div", {
			className: scrollArea(),
			children: documents.map(({ docId, title, description, status, cta, ctaTarget, ctaOnPress }) => {
				return /* @__PURE__ */ jsx(DocumentCell, {
					title,
					description: getDescription(status, description),
					variant: status,
					cta,
					ctaTarget,
					ctaOnPress
				}, docId);
			})
		})
	});
});
UploadSheet.displayName = "UploadSheet";
//#endregion
//#region src/application/UploadDocTracker/UploadDocTracker.tsx
/**
* UploadTracker Component
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/branch/ryoUajdQMDQWfUEmFqX7Uz/Negroni-Library?type=design&node-id=21813-3551&mode=design&t=L9AiWZTSZ9CsQbp8-0)
*/
function UploadDocTracker({ documents, isExpanded = true, onToggle, onClose }) {
	const sheetRef = useRef(null);
	const { width: windowWidth } = useWindowSize();
	const isSwipeable = windowWidth > 0 && windowWidth <= 768 || isTouchDevice();
	const [isOpen, setIsOpen] = useState(isExpanded);
	const sheetHeight = sheetRef.current?.getBoundingClientRect()?.height || 0;
	const y = useMotionValue(0);
	const opacity = useTransform(y, [sheetHeight, 0], [0, 1]);
	const [scope, animate] = useAnimate();
	const duration = useReducedMotion() ? 0 : .2;
	const animateClosed = useCallback(async () => {
		await animate(scope.current, { y: sheetHeight }, { duration });
	}, [
		animate,
		scope,
		duration,
		sheetHeight
	]);
	const animateOpen = useCallback(async () => {
		await animate(scope.current, { y: 0 }, { duration });
	}, [
		animate,
		scope,
		duration
	]);
	const handleToggle = () => {
		onToggle?.();
		setIsOpen((previousIsOpen) => !previousIsOpen);
	};
	const handleDragEnd = (event, info) => {
		if (info.offset.y > 50 || info.velocity.y > 20) handleToggle();
	};
	const handlePanEnd = (event, info) => {
		if (!isOpen && isSwipeable && info.offset.y < -10 && info.velocity.y < 0) handleToggle();
	};
	useEffect(() => {
		if (sheetHeight) if (isOpen) animateOpen();
		else animateClosed();
	}, [
		sheetHeight,
		isOpen,
		animateOpen,
		animateClosed
	]);
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [isOpen && /* @__PURE__ */ jsx(motion.div, {
		style: { opacity },
		onClick: handleToggle,
		className: "fixed bottom-0 left-0 right-0 top-0 touch-none bg-scrim md:hidden"
	}), /* @__PURE__ */ jsx("div", {
		className: "relative overflow-y-hidden pt-9",
		children: /* @__PURE__ */ jsx(motion.div, {
			drag: isSwipeable && isOpen ? "y" : void 0,
			onDragEnd: handleDragEnd,
			onPanEnd: handlePanEnd,
			dragListener: isOpen,
			dragMomentum: false,
			style: { y },
			dragConstraints: {
				top: 0,
				bottom: 100
			},
			dragElastic: 0,
			className: "relative rounded-t-lg border border-b-0 border-neutral-100 bg-white shadow-level-3 md:w-[448px]",
			ref: scope,
			children: /* @__PURE__ */ jsxs("div", {
				className: "touch-none",
				children: [/* @__PURE__ */ jsx(UploadHeader, {
					documents,
					isExpanded: isOpen,
					isSwipeable,
					onToggle: handleToggle,
					onClose: () => onClose?.()
				}), /* @__PURE__ */ jsx(UploadSheet, {
					documents,
					ref: sheetRef,
					isExpanded: true
				})]
			})
		})
	})] });
}
//#endregion
//#region src/application/TableToolbar/TableToolbar.tsx
/**
* Filter, search, and actions toolbar for use with Negroni Table.
*
* [Figma Spec](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?type=design&node-id=19694-8501&mode=design&t=TKoVUzlAT6CoSKMX-0)
*
* _Note:_ This component replaces `Filter`
*/
function TableToolbar({ actions, filters, selectedCount, totalItems, onDeleteClick, renderOverflowActions, onSearchChange, searchPlaceholder }) {
	const [showSearchBar, setShowSearchBar] = useState(false);
	const [searchValue, setSearchValue] = useState("");
	useEffect(() => {
		onSearchChange?.(searchValue);
	}, [searchValue]);
	const hasSelection = filters?.some((filter) => {
		if (filter.isMultiSelect) return filter.selectedKeys === "all" || Array.from(filter.selectedKeys || []).length > 0;
		return !!filter.selectedKey;
	});
	const toggleSearch = () => {
		setShowSearchBar(!showSearchBar);
	};
	const handleClearFilters = () => {
		const emptySet = /* @__PURE__ */ new Set([]);
		filters?.forEach((filter) => filter.isMultiSelect ? filter.onSelectionChange?.(emptySet) : filter.onSelectionChange?.(""));
	};
	return /* @__PURE__ */ jsxs("div", {
		className: "flex w-full items-end justify-between py-2",
		children: [selectedCount ? /* @__PURE__ */ jsxs("div", {
			className: "flex items-center gap-2",
			children: [
				/* @__PURE__ */ jsxs("span", {
					className: "text-body-1 text-neutral-800",
					children: [
						selectedCount,
						" ",
						selectedCount === 1 ? "item" : "items",
						" selected"
					]
				}),
				actions?.map((action) => /* @__PURE__ */ createElement(Button$1, {
					...action,
					key: action.label,
					icon: action.icon,
					size: "sm",
					color: "neutral",
					variant: "ghost"
				}, action.label)),
				onDeleteClick && /* @__PURE__ */ jsx(Button$1, {
					icon: TrashIcon,
					size: "sm",
					color: "error",
					variant: "ghost",
					children: "Delete"
				})
			]
		}) : /* @__PURE__ */ jsxs("div", {
			className: "flex items-center gap-2",
			children: [filters?.map((filter) => /* @__PURE__ */ jsx(Select$1, {
				className: "w-36",
				...filter,
				variant: "filter"
			}, filter.triggerText)), hasSelection && /* @__PURE__ */ jsxs(Fragment$1, { children: [Boolean(totalItems) && /* @__PURE__ */ jsxs("div", {
				className: "shrink-0 text-body-1 text-neutral-600",
				children: [
					totalItems,
					" ",
					totalItems === 1 ? "item" : "items"
				]
			}), /* @__PURE__ */ jsx(Button$1, {
				size: "sm",
				color: "neutral",
				variant: "ghost",
				className: "shrink-0",
				onPress: handleClearFilters,
				children: "Clear all"
			})] })]
		}), /* @__PURE__ */ jsxs("div", {
			className: "flex gap-2",
			children: [Boolean(onSearchChange) && (showSearchBar ? /* @__PURE__ */ jsx(Input$1, {
				placeholder: searchPlaceholder ?? "Search...",
				value: searchValue,
				onChange: setSearchValue,
				variant: "filter",
				"aria-label": "Search",
				icon: searchValue ? XIcon : void 0,
				onIconClick: () => !!searchValue && setSearchValue(""),
				autoFocus: true
			}) : /* @__PURE__ */ jsx(Button$1, {
				"aria-label": "Search",
				icon: SearchIcon,
				onPress: toggleSearch,
				size: "sm",
				variant: "outline",
				color: "neutral"
			})), renderOverflowActions?.()]
		})]
	});
}
//#endregion
//#region src/constants/states.ts
const states = {
	AL: "Alabama",
	AK: "Alaska",
	AZ: "Arizona",
	AR: "Arkansas",
	CA: "California",
	CO: "Colorado",
	CT: "Connecticut",
	DC: "Dist. of Columbia",
	DE: "Delaware",
	FL: "Florida",
	GA: "Georgia",
	HI: "Hawaii",
	ID: "Idaho",
	IL: "Illinois",
	IN: "Indiana",
	IA: "Iowa",
	KS: "Kansas",
	KY: "Kentucky",
	LA: "Louisiana",
	ME: "Maine",
	MD: "Maryland",
	MA: "Massachusetts",
	MI: "Michigan",
	MN: "Minnesota",
	MS: "Mississippi",
	MO: "Missouri",
	MT: "Montana",
	NE: "Nebraska",
	NV: "Nevada",
	NH: "New Hampshire",
	NJ: "New Jersey",
	NM: "New Mexico",
	NY: "New York",
	NC: "North Carolina",
	ND: "North Dakota",
	OH: "Ohio",
	OK: "Oklahoma",
	OR: "Oregon",
	PA: "Pennsylvania",
	RI: "Rhode Island",
	SC: "South Carolina",
	SD: "South Dakota",
	TN: "Tennessee",
	TX: "Texas",
	UT: "Utah",
	VT: "Vermont",
	VA: "Virginia",
	WA: "Washington",
	WV: "West Virginia",
	WI: "Wisconsin",
	WY: "Wyoming"
};
//#endregion
//#region src/application/InputField/InputField.tsx
const wrapValidate = (validate) => {
	if (!validate) return;
	return (value) => validate(value ?? "");
};
/**
* A specialized input field component designed to be used exclusively within the `Form` component.
* It integrates with `react-hook-form` for form validation and provides a consistent UI and error handling.
*/
function InputField(props) {
	const { rules, type, name, validate, value, defaultValue, isInvalid, onChange: onFieldChange, ...restProps } = props;
	return /* @__PURE__ */ jsx(Controller, {
		name,
		rules: {
			...rules,
			validate: wrapValidate(validate) ?? rules?.validate
		},
		defaultValue,
		render: ({ field: { onChange, onBlur, value: fieldValue, ref }, fieldState: { invalid, error } }) => {
			const handleOnChange = (inputValue) => {
				onChange(inputValue);
				onFieldChange?.(inputValue);
			};
			return /* @__PURE__ */ jsx(Input$1, {
				...restProps,
				name,
				defaultValue,
				ref,
				type,
				value: (value ?? fieldValue) || "",
				isInvalid: isInvalid ?? invalid,
				errorMessage: error?.message,
				onBlur,
				onChange: handleOnChange,
				validationBehavior: "aria"
			});
		}
	});
}
//#endregion
//#region src/application/utils/validation.ts
/** Worldpay gateway field length limits */
const WORLDPAY_NAME_MAX_LENGTH = 25;
const WORLDPAY_STREET_MAX_LENGTH = 35;
const requiredValidation = (message) => ({ required: {
	value: true,
	message
} });
const phoneValidator = (val) => {
	if (val.indexOf("_") === 1) return false;
	if (val.length > 10 && /^[(]\d{3}[)][ -]\d{3}-\d{4}$/.test(val)) return true;
	if (val.length > 10 && /^\d{3}-\d{3}-\d{4}$/.test(val)) return true;
	if (!validator.isMobilePhone(val)) return false;
	if (!/^\d{10}$/.test(val)) return false;
	return true;
};
const phoneValidation = { validate: (val = "") => phoneValidator(val) || "Please enter a valid phone number" };
const internationalPhoneValidator = (val = "") => {
	const normalized = val.replace(/[\s().-]/g, "");
	if (!/^\+?\d{7,15}$/.test(normalized)) return false;
	return validator.isMobilePhone(normalized, "any", { strictMode: false });
};
const internationalPhoneValidation = { validate: (val = "") => internationalPhoneValidator(val) || "Please enter a valid phone number" };
const usPhoneValidator = (val = "") => {
	return validator.isMobilePhone(val, "en-US", { strictMode: false });
};
const usPhoneValidation = { validate: (val = "") => usPhoneValidator(val) || "Please enter a valid US phone number" };
const isPhoneMask = (val) => {
	return !/[^-()_ ]/.exec(val);
};
/** Check for valid phone number or empty string. String containing only masks counts as empty. */
const allowEmptyPhoneValidation = { validate: (val = "") => {
	if (val === "") return true;
	return isPhoneMask(val) || phoneValidation.validate(val);
} };
const emailValidation = { validate: (val = "") => validator.isEmail(val) || "Please enter a valid email" };
/** Check for valid email address or empty string. */
const allowEmptyEmailValidation = { validate: (val = "") => {
	if (val === "") return true;
	return emailValidation.validate(val);
} };
const streetAddressValidation = {
	pattern: {
		value: /^[^<>]*$/,
		message: "Invalid \"<,>\" characters entered."
	},
	maxLength: {
		value: 35,
		message: `Street address cannot exceed 35 characters`
	}
};
const passwordValidation = { minLength: {
	value: 6,
	message: "Password must be at least 6 characters."
} };
const securityCodeValidation = { pattern: {
	value: /^\d{3,4}$/,
	message: "Please enter a valid Security code."
} };
const zipValidation = { pattern: {
	value: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
	message: "Please enter a valid billing ZIP code."
} };
const fullNameValidation = { pattern: {
	value: /^[a-zA-Z,.'-]+ [a-zA-Z,.'-]+$/,
	message: "Please enter a first and last name."
} };
const nameValidation = {
	pattern: {
		value: /^[a-zA-Z,.'-]+$/,
		message: "Invalid character(s) entered"
	},
	maxLength: {
		value: 25,
		message: `Cannot exceed 25 characters`
	}
};
const currencyValidation = { pattern: {
	value: /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/,
	message: "Please enter a valid amount."
} };
const currencyNegativeAllowedValidation = { pattern: {
	value: /(?=.*?\d)^-?\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/,
	message: "Please enter a valid amount."
} };
const numberValidation = { pattern: {
	value: /^\d+\.?(\d+)?$/,
	message: "Please enter a valid number."
} };
//#endregion
//#region src/application/AddressInputFields/AddressInputSet.tsx
const stateOptions = Object.entries(states).map(([key]) => ({
	id: key,
	name: key
}));
const getUnSelectedFieldState = (value) => ({
	selectedKey: null,
	street: value?.street || "",
	street2: value?.street2 || "",
	city: value?.city || "",
	state: value?.state || "",
	zip: value?.zip || ""
});
function AddressInputSet({ label, isValid = true, addressSuggestions, isMultilineStreet = false, autoFillMode, onStreetChange, streetInputProps, street2InputProps, cityInputProps, stateSelectProps, zipInputProps, isDisabled, onStreetSelectionChange, value, onChange }) {
	const [fieldState, setFieldState] = useState(getUnSelectedFieldState(value));
	useEffect(() => {
		setFieldState(getUnSelectedFieldState(value));
	}, [value]);
	const parsedAddresses = addressSuggestions?.map((address, index) => ({
		id: index,
		name: `${address.street}, ${address.city}, ${address.state}`
	}));
	const onChangeHandlers = {
		street: streetInputProps?.onChange,
		street2: street2InputProps?.onChange,
		city: cityInputProps?.onChange,
		state: stateSelectProps?.onSelectionChange,
		zip: zipInputProps?.onChange
	};
	const onFieldInputChange = (name, val) => {
		const newFieldState = {
			...fieldState,
			[name]: val
		};
		setFieldState(newFieldState);
		if (name === "street" && onStreetChange) onStreetChange(val);
		onChangeHandlers[name]?.(val);
		onChange?.(newFieldState);
	};
	const autoFill = (key) => {
		const selected = addressSuggestions?.find((_, index) => index === key);
		if (selected) {
			const newFieldState = {
				selectedKey: String(key),
				...selected
			};
			onStreetSelectionChange?.(selected);
			setFieldState(newFieldState);
			Object.entries(onChangeHandlers).forEach(([k, v]) => {
				if (newFieldState[k] !== fieldState[k]) v?.(newFieldState[k] || "");
			});
			onChange?.(newFieldState);
		}
	};
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col",
		children: [label && /* @__PURE__ */ jsx("div", {
			className: "mb-1 text-footnote",
			children: label
		}), /* @__PURE__ */ jsxs("fieldset", {
			className: "flex flex-col gap-2",
			children: [
				autoFillMode ? /* @__PURE__ */ jsx(Controller, {
					name: streetInputProps?.name || "street",
					rules: {
						required: true,
						...streetAddressValidation
					},
					render: ({ field: { onChange: onFieldChange }, fieldState: { error: hasError } }) => {
						const handleOnChange = (v) => {
							onFieldChange(v);
							onFieldInputChange("street", v);
						};
						return /* @__PURE__ */ jsx(Combobox, {
							"aria-label": "street",
							name: streetInputProps?.name || "street",
							placeholder: "Street",
							helperIcon: "search",
							selectedKey: fieldState.selectedKey,
							defaultItems: parsedAddresses,
							onInputChange: handleOnChange,
							onSelectionChange: autoFill,
							inputValue: fieldState.street,
							isInvalid: !isValid || !!hasError,
							isDisabled
						});
					}
				}) : /* @__PURE__ */ jsx(InputField, {
					"aria-label": "street",
					name: streetInputProps?.name || "street",
					className: "flex-1",
					placeholder: "Street",
					autoComplete: isMultilineStreet ? "address-line1" : "street-address",
					isInvalid: !isValid || void 0,
					isDisabled,
					maxLength: 35,
					value: fieldState.street,
					onChange: (val) => onFieldInputChange("street", val),
					rules: {
						required: true,
						...streetAddressValidation
					}
				}),
				isMultilineStreet && /* @__PURE__ */ jsx(InputField, {
					"aria-label": "street2",
					name: street2InputProps?.name || "street2",
					className: "flex-1",
					placeholder: "Apt, Suite Number",
					autoComplete: "address-line2",
					maxLength: 35,
					value: fieldState.street2,
					onChange: (val) => onFieldInputChange("street2", val),
					isInvalid: !isValid || void 0,
					isDisabled,
					rules: streetAddressValidation
				}),
				/* @__PURE__ */ jsx(InputField, {
					"aria-label": "city",
					name: cityInputProps?.name || "city",
					className: "flex-1",
					placeholder: "City",
					autoComplete: "address-level2",
					value: fieldState.city,
					onChange: (val) => onFieldInputChange("city", val),
					isDisabled,
					isInvalid: !isValid || void 0,
					rules: { required: true }
				}),
				/* @__PURE__ */ jsxs("div", {
					className: "flex gap-2",
					children: [/* @__PURE__ */ jsx("div", {
						className: "w-1/2",
						children: /* @__PURE__ */ jsx(Controller, {
							name: stateSelectProps?.name || "state",
							rules: { required: true },
							render: ({ field: { onChange: onFieldChange }, fieldState: { error: hasError } }) => {
								const handleOnChange = (key) => {
									if (key === null) return;
									onFieldChange(key);
									onFieldInputChange("state", stateOptions.find((state) => state.id === key)?.name || "");
								};
								return /* @__PURE__ */ jsx(Select$1, {
									"aria-label": "State",
									name: stateSelectProps?.name || "state",
									placeholder: "State",
									isInvalid: !isValid || !!hasError,
									options: stateOptions,
									selectedKey: stateOptions.find((state) => state.name === fieldState.state)?.id || null,
									onSelectionChange: handleOnChange,
									isDisabled
								});
							}
						})
					}), /* @__PURE__ */ jsx(InputField, {
						"aria-label": "ZIP Code",
						name: zipInputProps?.name || "zipCode",
						placeholder: "ZIP Code",
						className: "basis-1/2",
						autoComplete: "postal-code",
						value: fieldState.zip,
						mask: "99999",
						onChange: (val) => {
							onFieldInputChange("zip", val);
						},
						isInvalid: !isValid || void 0,
						isDisabled,
						rules: {
							required: true,
							pattern: /^\d{5}$/
						}
					})]
				})
			]
		})]
	});
}
//#endregion
//#region src/application/Form/Form.tsx
/**
* TODO: This component will be refactored to use React-Aria Form.
* https://react-spectrum.adobe.com/react-aria/forms.html
*/
function Form({ children, defaultValues, mode = "onSubmit", onSubmit, id, className, "data-testId": dataTestId }) {
	const form = useForm({
		defaultValues,
		mode
	});
	return /* @__PURE__ */ jsx(FormProvider, {
		...form,
		children: /* @__PURE__ */ jsx("form", {
			onSubmit: onSubmit && form.handleSubmit(onSubmit),
			className,
			id,
			"data-testid": dataTestId,
			children
		})
	});
}
//#endregion
//#region src/application/NameInputField/NameInputField.tsx
/**
* A specialized set of InputField components for first and last name designed to be used exclusively within the `Form` component.
* Handles a consistent look for first and last name fields and validation *
*/
function NameInputField(props) {
	return /* @__PURE__ */ jsxs("div", {
		className: "flex w-full gap-2",
		children: [/* @__PURE__ */ jsx(InputField, {
			...props,
			name: "firstName",
			label: "First name",
			placeholder: "First",
			maxLength: 25,
			rules: {
				...requiredValidation("Please enter first name"),
				...nameValidation
			},
			type: "text",
			block: true,
			onChange: (value) => {
				props.onFirstNameChange?.(value);
			},
			errorIcon: AlertTriangleIcon
		}), /* @__PURE__ */ jsx(InputField, {
			...props,
			name: "lastName",
			label: "Last name",
			placeholder: "Last",
			maxLength: 25,
			rules: {
				...requiredValidation("Please enter last name"),
				...nameValidation
			},
			type: "text",
			block: true,
			onChange: (value) => {
				props.onLastNameChange?.(value);
			},
			errorIcon: AlertTriangleIcon
		})]
	});
}
//#endregion
//#region src/application/Shell/ShellContent.tsx
const ShellSlot = ({ id, className, "data-testid": testId, isLoading, loader, children, loadingBehavior = "replace", tag: Tag = "div" }) => {
	const { isLoading: ctxLoading } = useShellContext();
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [loader && (ctxLoading || isLoading) && (loadingBehavior === "overlay" ? /* @__PURE__ */ jsx("div", {
		className: "absolute bottom-0 left-0 right-0 top-0 z-30 flex items-center justify-center",
		children: loader
	}) : loader), (loadingBehavior === "overlay" || !ctxLoading && !isLoading) && /* @__PURE__ */ jsx(Tag, {
		id,
		className,
		"data-testid": testId,
		children
	})] });
};
const PrimaryNavContent = ({ loader: customLoader, className, ...props }) => {
	const loader = customLoader ?? /* @__PURE__ */ jsx("div", {
		className: "flex size-full flex-col gap-3",
		children: Array.from(Array(8)).map((_, i) => /* @__PURE__ */ jsxs("div", {
			className: "flex h-8 items-center gap-2",
			children: [/* @__PURE__ */ jsx(Skeleton, {
				variant: "rounded",
				className: "h-8 w-8 shrink-0"
			}), /* @__PURE__ */ jsx(Skeleton, {})]
		}, i))
	});
	return /* @__PURE__ */ jsx(ShellSlot, {
		...props,
		className: cx("size-full", className),
		loader
	});
};
const TopNavContent = ({ loader: customLoader, className, ...props }) => {
	const loader = customLoader ?? /* @__PURE__ */ jsxs("div", {
		className: "flex w-32 items-center gap-2",
		children: [/* @__PURE__ */ jsx(Skeleton, {
			variant: "circular",
			className: "h-6 w-6 shrink-0"
		}), /* @__PURE__ */ jsx(Skeleton, {
			variant: "rounded",
			className: "h-6"
		})]
	});
	return /* @__PURE__ */ jsx(ShellSlot, {
		...props,
		className: cx("w-fit", className),
		loader
	});
};
const defaultMainContentLoader = /* @__PURE__ */ jsx("div", {
	className: "size-full p-3",
	children: /* @__PURE__ */ jsx(Skeleton, {
		variant: "rounded",
		className: "size-full"
	})
});
const MainContent = ({ loader: customLoader, className, ...props }) => {
	const loader = customLoader ?? defaultMainContentLoader;
	const rootContext = useShellContext();
	const ctxValue = useMemo(() => {
		return {
			...rootContext,
			isLoading: rootContext.isLoading || props.isLoading,
			customLoader: rootContext.customLoader || loader
		};
	}, [
		rootContext,
		props.isLoading,
		loader
	]);
	return /* @__PURE__ */ jsx(ShellContext.Provider, {
		value: ctxValue,
		children: /* @__PURE__ */ jsx(ShellSlot, {
			tag: "main",
			...props,
			className: cx("size-full overflow-auto", className),
			loader
		})
	});
};
//#endregion
//#region src/application/Shell/Shell.tsx
const Shell = ({ id, className, "data-testid": testId, isLoading, loader, logoHref, children, onSidenavExpandedChange, onNavHiddenChange, onMobileNavOpenChange, ...props }) => {
	const { width } = useWindowSize();
	const isMobile = width <= 768;
	const shellId = useId(id);
	const sidenavId = `${shellId}-sn`;
	const [isNavHidden, setIsNavHidden] = useState(props.isNavHidden ?? false);
	const [isMobileNavOpen, setIsMobileNavOpen] = useState(props.isMobileNavOpen ?? false);
	const [isSidenavExpanded, setIsSidenavExpanded] = useState(props.isSidenavExpanded ?? !isMobile);
	const [headerContainerElement, setHeaderContainerElement] = useState(null);
	const toggleSidenavExpanded = () => {
		setIsSidenavExpanded((prev) => {
			onSidenavExpandedChange?.(!prev);
			return !prev;
		});
	};
	const toggleMobileNavOpen = () => {
		if (!isMobile) return;
		setIsMobileNavOpen((prev) => {
			onMobileNavOpenChange?.(!prev);
			return !prev;
		});
	};
	useEffect(() => setIsSidenavExpanded(props.isSidenavExpanded ?? !isMobile), [props.isSidenavExpanded, isMobile]);
	useEffect(() => setIsMobileNavOpen(props.isMobileNavOpen && isMobile || false), [props.isMobileNavOpen, isMobile]);
	useEffect(() => setIsNavHidden(props.isNavHidden ?? false), [props.isNavHidden]);
	const ctxVal = useMemo(() => ({
		headerContainerElement,
		isLoading,
		isNavHidden,
		isSidenavExpanded,
		isMobileNavOpen,
		setIsSidenavExpanded: (expanded) => {
			setIsSidenavExpanded(expanded);
			onSidenavExpandedChange?.(expanded);
		},
		setIsMobileNavOpen: (open) => {
			if (!isMobile) return;
			setIsMobileNavOpen(open);
			onMobileNavOpenChange?.(open);
		},
		setIsNavHidden: (hidden) => {
			setIsNavHidden(hidden);
			onNavHiddenChange?.(hidden);
		}
	}), [
		headerContainerElement,
		isLoading,
		isNavHidden,
		isSidenavExpanded,
		isMobileNavOpen,
		onSidenavExpandedChange,
		isMobile,
		onMobileNavOpenChange,
		onNavHiddenChange
	]);
	const { primaryNavContent, topNavContent, mainContent } = getChildrenBySlots(children, {
		primaryNavContent: PrimaryNavContent,
		topNavContent: TopNavContent,
		mainContent: MainContent
	});
	return /* @__PURE__ */ jsx(ShellContext.Provider, {
		value: ctxVal,
		children: isLoading && !!loader ? loader : /* @__PURE__ */ jsxs("div", {
			id: shellId,
			"data-testid": testId,
			className: cx("flex h-dvh w-dvw bg-neutral-50", className),
			children: [!isNavHidden && /* @__PURE__ */ jsxs("div", {
				id: sidenavId,
				className: "hidden h-full flex-none flex-col bg-neutral-0 md:flex",
				children: [/* @__PURE__ */ jsxs("div", {
					className: cx("z-30 flex w-[48px] shrink-0 items-center justify-end gap-3 overflow-hidden bg-neutral-0 px-2 py-4 transition-all", isSidenavExpanded && "w-[212px]"),
					children: [/* @__PURE__ */ jsx(Link, {
						href: logoHref,
						target: "_self",
						className: cx("grow rounded-lg outline-none data-[focus-visible]:outline-kbf"),
						children: /* @__PURE__ */ jsx(Logo, {
							variant: "legalZoom",
							size: "sm"
						})
					}), /* @__PURE__ */ jsx(Button$1, {
						icon: CollapseIcon,
						variant: "ghost",
						color: "neutral",
						onPress: toggleSidenavExpanded,
						size: "sm",
						className: cx("my-2 flex-none text-neutral-600", !isSidenavExpanded && "rotate-180"),
						"aria-label": "Minimize side navigation",
						"aria-pressed": !isSidenavExpanded
					})]
				}), /* @__PURE__ */ jsx("div", {
					className: cx("z-20 mt-0 flex h-full w-[48px] overflow-hidden bg-neutral-0 px-2 pt-0 shadow-sm motion-safe:transition-[width]", isSidenavExpanded && "flex w-[212px] px-2"),
					children: /* @__PURE__ */ jsx("div", {
						className: "relative size-full",
						children: primaryNavContent
					})
				})]
			}), /* @__PURE__ */ jsxs("div", {
				className: "flex h-full flex-auto flex-col overflow-hidden",
				children: [!isNavHidden && /* @__PURE__ */ jsxs("div", {
					className: "z-20 flex h-14 w-full items-center justify-between bg-neutral-0 py-3 pl-3 pr-4 shadow-sm md:h-12 md:justify-end md:px-6 md:py-2",
					children: [/* @__PURE__ */ jsxs("div", {
						className: "flex items-center gap-1 md:hidden",
						children: [/* @__PURE__ */ jsxs(DialogTrigger, {
							onOpenChange: toggleMobileNavOpen,
							isOpen: isMobileNavOpen,
							children: [/* @__PURE__ */ jsx(Button$1, {
								icon: MenuIcon,
								variant: "ghost",
								color: "neutral",
								size: "lg",
								"aria-label": "Open navigation menu",
								className: "size-10"
							}), /* @__PURE__ */ jsx(Modal, {
								className: "absolute inset-0 z-30 h-full w-full bg-neutral-0 p-2 shadow-lg !duration-100 ease-in-out data-[entering]:motion-safe:animate-slide-in-horizontal data-[exiting]:motion-safe:animate-slide-out-horizontal",
								children: /* @__PURE__ */ jsxs(Dialog, {
									className: "flex h-full w-full flex-col focus-visible:outline-none active:outline-none",
									"aria-label": "Navigation Menu",
									children: [/* @__PURE__ */ jsxs("div", {
										className: "flex h-14 items-center gap-1",
										children: [/* @__PURE__ */ jsx(Button$1, {
											icon: XIcon,
											variant: "ghost",
											color: "neutral",
											onPress: toggleMobileNavOpen,
											size: "lg",
											className: "size-10",
											"aria-label": "Close navigation menu"
										}), /* @__PURE__ */ jsx(Link, {
											href: logoHref,
											target: "_self",
											className: cx("rounded-lg px-1 py-2 outline-none data-[focus-visible]:outline-kbf"),
											children: /* @__PURE__ */ jsx(Logo, {
												variant: "legalZoom",
												size: "sm"
											})
										})]
									}), primaryNavContent]
								})
							})]
						}), /* @__PURE__ */ jsx(Link, {
							href: logoHref,
							target: "_self",
							className: cx("grow rounded-lg px-1 py-2 data-[focus-visible]:outline-kbf"),
							children: /* @__PURE__ */ jsx(Logo, {
								variant: "mark",
								size: "sm"
							})
						})]
					}), /* @__PURE__ */ jsx("div", {
						className: "relative",
						children: topNavContent
					})]
				}), /* @__PURE__ */ jsxs("div", {
					className: "relative flex size-full flex-col overflow-hidden",
					children: [/* @__PURE__ */ jsx("div", {
						id: "header-container",
						ref: setHeaderContainerElement
					}), mainContent]
				})]
			})]
		})
	});
};
Shell.PrimaryNavContent = PrimaryNavContent;
Shell.TopNavContent = TopNavContent;
Shell.MainContent = MainContent;
//#endregion
export { ShortcutsBase as A, NotEntitledConversationListCell as B, usPhoneValidator as C, UploadDocTracker as D, TableToolbar as E, FileChipDocument as F, ErrorContainer as I, ExpertCard as L, MessageThread as M, MessageRow as N, DocumentCell as O, FileChip as P, ConversationListCell as R, usPhoneValidation as S, InputField as T, ActivityFeed as V, passwordValidation as _, WORLDPAY_NAME_MAX_LENGTH as a, securityCodeValidation as b, allowEmptyPhoneValidation as c, emailValidation as d, fullNameValidation as f, numberValidation as g, nameValidation as h, AddressInputSet as i, ProcessingButton as j, Stepper as k, currencyNegativeAllowedValidation as l, internationalPhoneValidator as m, NameInputField as n, WORLDPAY_STREET_MAX_LENGTH as o, internationalPhoneValidation as p, Form as r, allowEmptyEmailValidation as s, Shell as t, currencyValidation as u, phoneValidation as v, zipValidation as w, streetAddressValidation as x, requiredValidation as y, EmptyConversationListCell as z };

//# sourceMappingURL=application-CRl6JCyA.mjs.map